interface SupabaseError {
  code?: string;
  message?: string;
  details?: string | null;
  hint?: string | null;
}

export const parseSupabaseError = (error: unknown): string => {
  if (!error || typeof error !== "object") {
    return "An unexpected error occurred. Please try again.";
  }

  const supabaseError = error as SupabaseError;

  // Handle duplicate key constraint errors
  if (supabaseError.code === "23505") {
    if (supabaseError.message?.includes("analysis_entity_tenant_id_email_key")) {
      return "This email address is already registered. Please use a different email address.";
    }
    return "A record with this information already exists. Please use different values.";
  }

  // Handle other common Supabase errors
  if (supabaseError.code === "23503") {
    return "Cannot complete this action due to related records. Please check your data.";
  }

  if (supabaseError.code === "42501") {
    return "You don't have permission to perform this action.";
  }

  if (supabaseError.code === "PGRST301") {
    return "The requested record was not found.";
  }

  // Return the original error message if it exists, otherwise a generic message
  if (supabaseError.message) {
    return supabaseError.message;
  }

  return "An unexpected error occurred. Please try again.";
};
